import React from "react";
const FileQuestionInput = (props) => {
    var _a, _b;
    return (React.createElement("div", { className: `inputReadOnly` },
        React.createElement("label", { dangerouslySetInnerHTML: { __html: props.title ? props.title : "" } }),
        React.createElement("p", null,
            React.createElement("a", { href: `${(_a = props.currentValue) === null || _a === void 0 ? void 0 : _a.uri}`, target: "_blank", rel: "noreferrer" }, (_b = props.currentValue) === null || _b === void 0 ? void 0 : _b.fileName))));
};
export default FileQuestionInput;
